export default "__VITE_ASSET__CNwxgdUN__"